<script setup lang="ts">
const route = useRoute()
const slug = computed(() => route.params.slug)

// Password protection for factories page
const isFactoriesPage = computed(() => slug.value === 'factories')
const isAuthenticated = ref(false)
const password = ref('')
const passwordError = ref('')
const handlePasswordSubmit = () => {
  if (password.value === 'factory@nitex') {
    isAuthenticated.value = true
    passwordError.value = ''
  } else {
    passwordError.value = 'Incorrect password. Please try again.'
    password.value = ''
  }
}

const { data, error } = await useSanityQuery<PageProps>(getPage, { slug })

if (error.value || !data.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })
}

useSanitySeo(data.value?.seo)

if (data.value?.title) {
  route.meta.pageTitle = data.value.title
}

const { setSectionsData, refresh } = useActiveSection()

onMounted(() => {
  setSectionsData(data.value?.pageSections || [])
  setTimeout(refresh)
})
</script>

<template>
  <div class="bg-light-grey h-fit pt-14">
    <!-- <SiteHeader /> -->

    <!-- Password Protection for Factories Page -->
    <div
      v-if="isFactoriesPage && !isAuthenticated"
      class="flex min-h-screen items-center justify-center"
    >
      <div class="bg-neon-yellow mx-4 w-full max-w-md p-8 shadow-lg">
        <div class="mb-6 text-center">
          <h1 class="font-display mb-2 mb-6 text-xl uppercase font-stretch-expanded">
            Protected Page
          </h1>
          <p class="e-portable-text rte text-base">
            Please enter the password to access the Factories page.
          </p>
        </div>
        <form class="space-y-4" @submit.prevent="handlePasswordSubmit">
          <div>
            <label for="password" class="mb-2 block font-mono text-sm uppercase"> Password </label>
            <input
              id="password"
              v-model="password"
              type="password"
              placeholder="Enter password"
              class="selection:!text-neon-yellow w-full border border-black/50 p-3 selection:!bg-black"
              required
            />
          </div>
          <div v-if="passwordError" class="text-sm text-red-600">
            {{ passwordError }}
          </div>
          <button
            type="submit"
            class="text-neon-yellow inline-block w-full cursor-pointer bg-black p-3 font-mono text-sm uppercase"
          >
            Submit
          </button>
        </form>
      </div>
    </div>

    <div v-else>
      <div
        class="flex flex-col gap-6 pb-6 lg:gap-8 lg:pb-8"
        :style="['--page-cta-bg: var(--color-neon-yellow); --page-cta-text: var(--color-black);']"
      >
        <PageSections v-if="data?.pageSections" :sections="data.pageSections" :template="'page'" />
      </div>

      <SiteFooter />
    </div>
  </div>
</template>
